export const VALID_CHARACTERS_REGEX = /^(\w|\s|-)*$/i;

export const validateIsValidCharacters = (value: string) =>
  VALID_CHARACTERS_REGEX.test(value) === true;
